import {takeEvery, put} from "redux-saga/effects";
import {DefaultTheme} from "styled-components";
import ThemeAction, {ThemeActionTypes} from "@fkhplus/common/src/modules/theme/actions";
import {IFluxStandardAction} from "@fkhplus/common/src/modules/interfaces";
import {Themes} from "@fkhplus/common/src/styles/themes";

function* switchTheme(action: IFluxStandardAction<string>): Generator {

    const {payload = 'default'} = action;
    try {
        const theme: DefaultTheme = Themes.getThemeByName(payload);
        yield put(ThemeAction.switchThemeSuccess(theme));
    } catch (e) {
        //
    }
}

function* watchThemeSagas(): Generator {
    yield takeEvery(ThemeActionTypes.SWITCH, switchTheme)
}

export default watchThemeSagas;
